import { observer } from 'mobx-react'
import styles from './CustomerServiceModal.module.less'
import { Modal } from 'antd'
import { IconImage } from '@/components/Icon/Icon'
import CustomerQr from '@/assets/images/customer_wxqr.png'

export interface CustomerServiceModalProps {
  visible: boolean
  onClose: () => void
}

const CustomerServiceModal = observer(({ visible, onClose }: CustomerServiceModalProps) => {
  return (
    <Modal
      open={visible}
      footer={null}
      closeIcon={false}
      onCancel={onClose}
      width={282}
      centered
      title={null}
      styles={{
        body: { padding: 0 },
        content: {
          padding: 0,
          borderRadius: 8,
          overflow: 'hidden',
          backgroundColor: 'transparent',
        },
      }}
    >
      <div className={styles.customerServiceModal}>
        <div className={styles.modalClose} onClick={onClose}>
          <IconImage width={16} className={styles.closeImg} src='IconClose' />
        </div>
        <div className={styles.modalContent}>
          <div className={styles.boxTitle}>添加客服</div>
          <div className={styles.boxSubtitle}>
            <IconImage src='IconCustomerStar' width={17} height={17} />
            扫码联系专属客服
          </div>
          <div className={styles.customerQr}>
            <img
              className={styles.customerQrImg}
              src={CustomerQr}
              alt='客服二维码'
              draggable={false}
            />
          </div>
        </div>
      </div>
    </Modal>
  )
})

export default CustomerServiceModal
